// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__GBokl","handle":"Controls_handle__0Gw6d"};